<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <div class="qi-content">
        <header>
          <h1>Cronograma do Aluno</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox>
        </vs-row>
        <vs-row vs-justify="left">
          <vs-col vs-w="10" v-if="resultSearch && student">
            <h2>
              Estudante selecionado: {{ student.NOME }} [RA: {{ student.RA }}]
            </h2>
          </vs-col>
          <vs-col>
            <vs-table class="pd-table" striped :data="subjects">
              <template slot="thead">
                <th class="col-pequena">IdTurma</th>
                <th class="col-pequena">CodTurma</th>
                <th class="col-pequena">Vagas</th>
                <th class="col-expandida">Disciplina</th>
                <th class="col-media">Data Prevista</th>
                <th class="col-media">Dia da Semana/Horário</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  v-for="subject in data"
                  :key="subject.IDTURMADISC"
                  :class="subject.approval ? 'eliminated' : 'normal'"
                >
                  <vs-td class="col-pequena">{{ subject.IDTURMADISC != "0" ? subject.IDTURMADISC : "-" }}</vs-td>
                  
                  <vs-td class="col-pequena" :title="subject.CODTURMA">{{ subject.IDTURMADISC != "0" ? subject.CODTURMA : "-" }}</vs-td>
                  
                  <vs-td class="col-pequena" style="text-align: center">{{ subject.IDTURMADISC != "0" ? subject.VAGAS : "-" }}</vs-td>
                  
                  <vs-td class="col-expandida">
                    {{ subject.DISCIPLINA }} ({{ subject.CH }}h)
                    <div v-if="stepsData.course.MODALIDADE == 'Graduação' && subject.MODALIDADEDISC == 'Presencial'" style="display: flex; margin-top: 3.5px">
                      <span style="font-size: 15px; margin-right: 3.5px" class="material-icons">description</span>
                      <span>{{ subject.MODALIDADEDISC.toUpperCase() }}</span>
                    </div>
                  </vs-td>
                  
                  <vs-td class="col-media">{{ subject.IDTURMADISC != "0" ? formatData(subject.DTINICIAL, subject.DTFINAL) : "NÃO INCLUSA" }}</vs-td>
                  
                  <vs-td class="col-media" :title="subject.MODALIDADE != 'D' ? subject.HORARIO : 'À distância'">
                    {{ subject.MODALIDADE != "D" ? subject.HORARIO : "À distância" }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <vs-alert
              title="Erro ao montar o cronograma do aluno. Por favor contate o Suporte. "
              class="margin"
              color="danger"
              v-if="error"
            >
              {{ error }}
            </vs-alert>
          </vs-col>
        </vs-row>
        <vs-row style="margin: auto">
          <vs-col vs-w="4" vs-xs="12">
            <vs-button
              icon="arrow_back"
              style="width: 100%"
              @click="backToClasses()"
              type="filled"
            >
              Voltar para Turmas
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <vs-button
              :icon="iconButton"
              style="width: 100%"
              @click="showForm()"
              type="filled"
              color="danger"
            >
              {{ textButton }}
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <vs-button
              icon="check_circle"
              style="width: 100%"
              @click="goFoward()"
              color="#139B0E"
              :disabled="error"
            >
              Confirmar e Avançar
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-popup
          title="Pesquisar Estudante por CPF"
          :active.sync="search"
          class="text-align"
        >
          <vs-row class="border_col">
            <vs-col>
              <vs-input
                label="CPF do Estudante:"
                v-mask="'###.###.###-##'"
                v-model="cpf"
                v-on:keyup.13="searchStudent(cpf)"
              />
            </vs-col>
            <vs-col>
              <vs-button
                style="width: 100%"
                icon="search"
                @click="searchStudent(cpf)"
              >
                Localizar
              </vs-button>
            </vs-col>
          </vs-row>

          <vs-row v-if="resultSearch && !student"
            ><vs-col>
              <p>
                O sistema não localizou nenhum registro de aluno com este CPF na
                base de alunos da QI.
              </p>
            </vs-col>
          </vs-row>
        </vs-popup>
      </div>
    </div>
    <ConsultValidationMat />
  </div>
</template>

<script>
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import ConsultValidationMat from "../components/ConsultValidationMat.vue"
import {
  getStepsInformation,
  updateStepsInformation,
} from "../helpers/storage";
import CoursesService from "../services/courses";
import { formatDateToLocale, updateDiscussion } from "../helpers";
import PersonService from "../services/person";

export default {
  name: "Subjects",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
    ConsultValidationMat
  },
  data: () => ({
    subjects: [],
    error: null,
    stepsData: [],
    search: false,
    cpf: null,
    student: null,
    resultSearch: false,
    iconButton: "list",
    textButton: "Verificar Disciplinas já Cursadas",
  }),
  mounted() {
    this.$vs.loading({
      color: "danger",
    });

    this.stepsData = getStepsInformation();
    console.log(this.stepsData);
    updateStepsInformation({ student: this.student });

    let hasIntroductory = 0;
    if (this.stepsData.introductory)
      hasIntroductory = this.stepsData.introductory.IDTURMADISC;
    let hasElectives = [];
    let qtd = 0;
    if (this.stepsData.electives) {
      this.stepsData.electives.forEach((element) => {
        qtd = hasElectives.push(element.CODDISC);
      });
    }
    for (var i = qtd; i < 3; i++) {
      hasElectives.push(0);
    }
    new CoursesService()
      .getSubjects(
        this.stepsData.classData.IDTURMADISC,
        this.stepsData.offer.CODCURSO,
        this.stepsData.course.IDCLASSIFICACAO,
        hasIntroductory,
        this.stepsData.offer.IDHABILITACAOFILIAL,
        hasElectives[0],
        hasElectives[1],
        hasElectives[2],
        this.stepsData.offer.CODCAMPUS
      )
      .then(({ data }) => {
        const subs = Array.isArray(data) ? data : [data];
        this.subjects = subs.map((subject) => ({
          ...subject,
          IDHABILITACAOFILIAL: this.stepsData.offer.IDHABILITACAOFILIAL,
          MODALIDADE: this.stepsData.offer.MODALIDADE,
        }));
        this.$vs.loading.close();
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error = response.data.error;
        }
        this.$vs.loading.close();
      });
  },
  methods: {
    showForm() {
      if (this.textButton == "Limpar Aluno") {
        this.$router.go();
      } else this.search = !this.search;
    },

    async searchStudent(cpf) {
      this.resultSearch = false;
      let result = false;
      this.student = await this.findStudent(cpf);

      if (this.student) {
        this.iconButton = "delete";
        this.textButton = "Limpar Aluno";
        this.$vs.loading({
          color: "danger",
        });
        this.search = false;
        let subjectsResult = [];
        for (let subject of this.subjects) {
          result = await this.checkApproval(
            this.student.RA,
            subject.CODDISC,
            subject.IDHABILITACAOFILIAL
          );
          if (result) {
            subject.approval = true;
          }
          subjectsResult.push(subject);
        }
        this.subjects = subjectsResult;
        this.$vs.loading.close();
      } else {
        this.textButton = "Verificar Disciplinas já Cursadas";
      }
    },

    async checkApproval(ra, disciplineId, qualificationId) {
      let result = false;
      await new PersonService()
        .checkApproval(ra, disciplineId, qualificationId)
        .then(({ data }) => {
          result = data;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        });
      return result;
    },

    goFoward() {
      this.$vs.loading({
        color: "danger",
      });
      if (this.student) {
        this.subjects = this.subjects.filter((subject) => !subject.approval);
        let courseValue = 0;
        for (let i = 0; i < this.subjects.length; i++)
          if (this.subjects[i].VALOR)
            courseValue += Number(this.subjects[i].VALOR);
        this.stepsData.course.VALOR = courseValue;
      }
      updateDiscussion("Confirmou Cronograma de Disciplinas do Aluno", {
        subjects: this.subjects,
        student: this.student,
        course: this.stepsData.course,
      }).finally(() => {
        this.$router.push("/tax");
        this.$vs.loading.close();
      });
    },
    formatData(inicialDate, finalDate) {
      if (inicialDate == finalDate) return formatDateToLocale(inicialDate);
      else
        return `${formatDateToLocale(inicialDate)} a ${formatDateToLocale(
          finalDate
        )}`;
    },
    backToClasses() {
      this.$router.push("/classes");
    },

    async findStudent(cpf, type = "A") {
      this.$vs.loading();
      let result = null;
      await new PersonService()
        .getPerson(
          cpf.replace(/\D/g, ""),
          null,
          this.stepsData.offer.CODCURSO,
          type
        )
        .then(({ data }) => {
          result = data;
          this.resultSearch = true;
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
      return result;
    },
  },
};
</script>
<style scoped>

.col-pequena, .col-media {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-pequena {
  width: 10%;
  text-align: center !important;
}

.col-media {
  width: 20%;
}

.col-expandida {
  width: 30%;
  white-space: normal;
}

.pd-table table {
  table-layout: fixed;
  width: 100%;
}

.eliminated {
  text-decoration: line-through;
  color: red;
}
</style>
